var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_Profile",
    "data-name": "No Profile",
    transform: "translate(-861 -240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "No_Profile-2",
    "data-name": "No Profile",
    d: "M169,198A99,99,0,1,0,70,99,99,99,0,0,0,169,198Z",
    transform: "translate(791 240)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "No_Profile-3",
    "data-name": "No Profile",
    d: "M169,47.566a23.589,23.589,0,1,1-16.634,6.91A23.544,23.544,0,0,1,169,47.566Zm-32.538,66.461a46.019,46.019,0,0,1,78.558,32.538H122.981a45.716,45.716,0,0,1,13.481-32.538Z",
    transform: "translate(791.019 242.434)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileReplace);
export default __webpack_public_path__ + "static/media/ProfileReplace.af6802d36ab184722f85a4e2abd3d11c.svg";
export { ForwardRef as ReactComponent };